// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mobile and Desktop visibility classes */
.desktop-only {
  display: block;
}

.mobile-only {
  display: none !important;
}

.short-feed {
  width: 100%;
  max-width: 600px;
  min-height: 100vh;
  --feed-header-height: 64px;
}

/* When maincontentMode = wide: allow short-feed to expand and add side padding */
:root[data-maincontent="wide"] .short-feed {
  max-width: 100%;
}

:root[data-maincontent="wide"] .short-feed .feed-posts {
  padding-left: 20px;
  padding-right: 20px;
}

:root[data-maincontent="wide"] .feed-create-section {
  padding: 12px 35px;
}


/* Feed Stick - Sticky wrapper */
.feed-stick {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: var(--bg-primary);
  backdrop-filter: blur(12px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* In header layout, feed-stick sticks below header */
.App.header-layout .feed-stick {
  top: 60px;
}

/* Feed Header */
.feed-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-color);
  background-color: var(--bg-primary);
  gap: 12px;
}

.menu-open-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transition: background-color 0.2s;
  flex-shrink: 0;
}

.menu-open-btn:hover {
  background: var(--hover-bg);
}

.menu-open-btn svg {
  width: 24px;
  height: 24px;
}

.feed-selector {
  flex: 1 1;
}

.feed-dropdown {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 8px;
  transition: background-color 0.2s;
}

.feed-dropdown:hover {
  background: var(--hover-bg);
}

.feed-dropdown option {
  background: var(--card-bg);
  color: var(--text-primary);
  font-size: 16px;
  font-weight: 500;
  padding: 8px;
}

.feed-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 1.3rem 0;
}

/* Feed Tabs */
.feed-tabs {
  display: flex;
  overflow-x: hidden;
  scrollbar-width: none;
}

.feed-tabs::-webkit-scrollbar {
  display: none;
}

.feed-tab {
  flex: 1 1;
  min-width: fit-content;
  padding: 14px 16.5px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font-size: 15px;
  font-weight: 500;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s;
}

.feed-tab:hover {
  background: var(--hover-bg);
  color: var(--text-primary);
}

.feed-tab.active {
  color: var(--primary-color);
  border-bottom-color: var(--primary-color) !important;
  font-weight: 700;
}

.feed-tab-lists-wrapper {
  position: relative;
  flex-shrink: 0;
}

.feed-tab-lists {
  white-space: nowrap;
}

.feed-tab-lists-dropdown {
  position: fixed;
  z-index: 1000;
  min-width: 180px;
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.2);
  overflow: hidden;
}

.feed-tab-lists-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 10px 14px;
  background: none;
  border: none;
  color: var(--text-primary);
  font-size: 14px;
  cursor: pointer;
  text-align: left;
}

.feed-tab-lists-item:hover {
  background: var(--hover-bg);
}

.lists-item-name {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lists-item-count {
  font-size: 12px;
  color: var(--text-secondary);
  flex-shrink: 0;
}

/* Sort Tabs (Desktop) */
.feed-sort-tabs {
  display: flex;
  overflow-x: auto;
  scrollbar-width: none;
  border-top: 1px solid var(--border-color);
  background-color: var(--card-bg);
}

.feed-sort-tabs::-webkit-scrollbar {
  display: none;
}

.feed-sort-tab {
  flex: 1 1;
  min-width: fit-content;
  padding: 10px 16px;
  background: none;
  border: none;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s;
}

.feed-sort-tab:hover {
  background: var(--hover-bg);
  color: var(--text-primary);
}

.feed-sort-tab.active {
  color: var(--primary-color);
  font-weight: 700;
}

/* Mobile Sort Dropdown */
.feed-sort-dropdown {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-secondary);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 8px;
  transition: background-color 0.2s;
  max-width: none;
}

.feed-sort-dropdown:hover {
  background: var(--hover-bg);
}

.feed-sort-dropdown option {
  background: var(--card-bg);
  color: var(--text-primary);
  font-size: 14px;
  padding: 8px;
}

/* Create Post Section */
.feed-create-section {
  padding: 12px 20px;
  border-top: 1px solid var(--border-color);
}

.create-post-btn {
  width: 100%;
  padding: 10px 16px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.create-post-btn:hover {
  background: var(--primary-hover);
}

.login-prompt-btn {
  text-align: center;
}

.login-prompt-btn:hover {
  background: var(--primary-hover);
}

.create-post-inline {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.create-post-textarea {
  width: 100%;
  min-height: 80px;
  padding: 12px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  color: var(--text-primary);
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  outline: none;
}

.create-post-textarea:focus {
  border-color: var(--primary-color);
}

.create-post-textarea::placeholder {
  color: var(--text-secondary);
}

.create-post-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.char-count {
  font-size: 13px;
  color: var(--text-secondary);
}

.composer-meta-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.preview-create-btn {
  padding: 6px 12px;
  border: 1px solid var(--border-color);
  border-radius: 14px;
  background: transparent;
  color: var(--text-secondary);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.preview-create-btn:hover:not(:disabled) {
  background: var(--hover-bg);
  color: var(--text-primary);
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.cancel-create-btn,
.post-create-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.cancel-create-btn {
  background: var(--bg-secondary);
  color: var(--text-primary);
}

.cancel-create-btn:hover:not(:disabled) {
  background: var(--hover-bg);
}

.post-create-btn {
  background: var(--primary-color);
  color: white;
}

.post-create-btn:hover:not(:disabled) {
  background: var(--primary-hover);
}

.post-create-btn:disabled,
.cancel-create-btn:disabled,
.preview-create-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.refresh-btn {
  background: none;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--text-primary);
  transition: background-color 0.2s;
}

.refresh-btn.has-new {
  background: rgba(29, 155, 240, 0.12);
  box-shadow: 0 0 0 1px rgba(29, 155, 240, 0.5);
}

.refresh-btn.has-new .refresh-text,
.refresh-btn.has-new .refresh-icon {
  color: var(--primary-color);
}

.refresh-btn:hover {
  background: var(--hover-bg);
}

.refresh-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.refresh-icon {
  width: 20px;
  height: 20px;
  color: var(--primary-color);
}

.refresh-text {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  text-transform: lowercase;
}

.refresh-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--primary-color);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}

.new-posts-fab {
  position: fixed;
  top: calc(var(--feed-header-height) + 12px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 300;
  background: var(--primary-color);
  color: #fff;
  padding: 8px 18px;
  border-radius: 999px;
  border: none;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.new-posts-fab:hover {
  transform: translateX(-50%) translateY(-1px);
}

/* In header-layout mode, feed stick is offset by 60px */
.App.header-layout .new-posts-fab {
  top: calc(var(--feed-header-height) + 72px);
}

.refresh-icon.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Feed Content */
.feed-loading {
  display: flex;
  justify-content: center;
  padding: 40px 20px;
}

.feed-empty {
  padding: 60px 20px;
  text-align: center;
}

.feed-empty p {
  color: var(--text-secondary);
  font-size: 15px;
  line-height: 1.5;
  margin: 0;
}

.feed-posts {
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  padding-right: 10px;
}

/* Load More */
.feed-load-more {
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid var(--border-color);
}

.load-more-spinner {
  display: flex;
  justify-content: center;
}


.load-more-btn {
  padding: 10px 24px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.load-more-btn:hover:not(:disabled) {
  background: var(--primary-hover);
}

.load-more-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Responsive Design */
@media (max-width: 768px) {
  .desktop-only {
    display: none !important;
  }
  
  .mobile-only {
    display: block !important;
  }
  
  .short-feed {
    border-left: none;
    border-right: none;
    max-width: 100%;
  }

  .feed-header {
    padding: 12px 8px;
    gap: 4px;
  }

  .menu-open-btn {
    width: 40px;
    height: 40px;
  }

  .feed-title {
    font-size: 18px;
  }
  
  .feed-dropdown {
    /*flex: 1;*/
    max-width: none;
    font-size: 14px;
    font-weight: 600;
    padding: 6px 10px;
  }
  
  .refresh-btn {
    padding: 6px 8px;
    flex-shrink: 0;
  }
  
  .refresh-icon {
    width: 20px;
    height: 20px;
  }

  .new-posts-fab {
    top: calc(var(--feed-header-height) + 8px);
    padding: 8px 14px;
    font-size: 12px;
    max-width: calc(100vw - 24px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .App.header-layout .new-posts-fab {
    top: calc(var(--feed-header-height) + 68px);
  }
  
  .feed-tabs.desktop-only {
    display: none;
  }
}

/* Mobile Lists Panel */
.mobile-lists-backdrop {
  position: fixed;
  inset: 0;
  z-index: 400;
  background: rgba(0, 0, 0, 0.45);
}

.mobile-lists-panel {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 401;
  width: 75vw;
  max-width: 300px;
  background: var(--bg-primary);
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.3);
  animation: mobile-lists-slide-in 0.22s ease;
}

@keyframes mobile-lists-slide-in {
  from { transform: translateX(100%); }
  to   { transform: translateX(0); }
}

.mobile-lists-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid var(--border-color);
  flex-shrink: 0;
}

.mobile-lists-panel-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--text-primary);
}

.mobile-lists-panel-close {
  background: none;
  border: none;
  font-size: 24px;
  line-height: 1;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 0 2px;
}

.mobile-lists-panel-close:hover {
  color: var(--text-primary);
}

.mobile-lists-panel-list {
  list-style: none;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  flex: 1 1;
}

.mobile-lists-panel-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 14px 16px;
  background: none;
  border: none;
  border-bottom: 1px solid var(--border-color);
  color: var(--text-primary);
  font-size: 15px;
  text-align: left;
  cursor: pointer;
}

.mobile-lists-panel-item:hover {
  background: var(--hover-bg);
}

.mobile-lists-panel-name {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-lists-panel-count {
  font-size: 12px;
  color: var(--text-secondary);
  flex-shrink: 0;
  margin-left: 8px;
}

`, "",{"version":3,"sources":["webpack://./src/components/ShortFeed/ShortFeed.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,iFAAiF;AACjF;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA,gCAAgC;AAChC;EAEE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,mCAAmC;EACnC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,qDAAqD;AACrD;EACE,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,oDAAoD;EACpD,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,qCAAqC;EACrC,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;EAGE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,gCAAgC;EAChC,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,wDAAwD;AACxD;EACE,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;;AAGA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,0CAA0C;IAC1C,iBAAiB;IACjB,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,wBAAwB,EAAE;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,4CAA4C;EAC5C,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* Mobile and Desktop visibility classes */\r\n.desktop-only {\r\n  display: block;\r\n}\r\n\r\n.mobile-only {\r\n  display: none !important;\r\n}\r\n\r\n.short-feed {\r\n  width: 100%;\r\n  max-width: 600px;\r\n  min-height: 100vh;\r\n  --feed-header-height: 64px;\r\n}\r\n\r\n/* When maincontentMode = wide: allow short-feed to expand and add side padding */\r\n:root[data-maincontent=\"wide\"] .short-feed {\r\n  max-width: 100%;\r\n}\r\n\r\n:root[data-maincontent=\"wide\"] .short-feed .feed-posts {\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n}\r\n\r\n:root[data-maincontent=\"wide\"] .feed-create-section {\r\n  padding: 12px 35px;\r\n}\r\n\r\n\r\n/* Feed Stick - Sticky wrapper */\r\n.feed-stick {\r\n  position: -webkit-sticky;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 100;\r\n  background-color: var(--bg-primary);\r\n  backdrop-filter: blur(12px);\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* In header layout, feed-stick sticks below header */\r\n.App.header-layout .feed-stick {\r\n  top: 60px;\r\n}\r\n\r\n/* Feed Header */\r\n.feed-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 16px 20px;\r\n  border-bottom: 1px solid var(--border-color);\r\n  background-color: var(--bg-primary);\r\n  gap: 12px;\r\n}\r\n\r\n.menu-open-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: var(--text-primary);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  transition: background-color 0.2s;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.menu-open-btn:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.menu-open-btn svg {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n\r\n.feed-selector {\r\n  flex: 1;\r\n}\r\n\r\n.feed-dropdown {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 4px 8px;\r\n  border-radius: 8px;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.feed-dropdown:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.feed-dropdown option {\r\n  background: var(--card-bg);\r\n  color: var(--text-primary);\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  padding: 8px;\r\n}\r\n\r\n.feed-title {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin: 1.3rem 0;\r\n}\r\n\r\n/* Feed Tabs */\r\n.feed-tabs {\r\n  display: flex;\r\n  overflow-x: hidden;\r\n  scrollbar-width: none;\r\n}\r\n\r\n.feed-tabs::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.feed-tab {\r\n  flex: 1;\r\n  min-width: fit-content;\r\n  padding: 14px 16.5px;\r\n  background: none;\r\n  border: none;\r\n  border-bottom: 2px solid transparent;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.feed-tab:hover {\r\n  background: var(--hover-bg);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.feed-tab.active {\r\n  color: var(--primary-color);\r\n  border-bottom-color: var(--primary-color) !important;\r\n  font-weight: 700;\r\n}\r\n\r\n.feed-tab-lists-wrapper {\r\n  position: relative;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.feed-tab-lists {\r\n  white-space: nowrap;\r\n}\r\n\r\n.feed-tab-lists-dropdown {\r\n  position: fixed;\r\n  z-index: 1000;\r\n  min-width: 180px;\r\n  background: var(--card-bg);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 10px;\r\n  box-shadow: 0 6px 20px rgba(0,0,0,0.2);\r\n  overflow: hidden;\r\n}\r\n\r\n.feed-tab-lists-item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  width: 100%;\r\n  padding: 10px 14px;\r\n  background: none;\r\n  border: none;\r\n  color: var(--text-primary);\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  text-align: left;\r\n}\r\n\r\n.feed-tab-lists-item:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.lists-item-name {\r\n  flex: 1;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.lists-item-count {\r\n  font-size: 12px;\r\n  color: var(--text-secondary);\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Sort Tabs (Desktop) */\r\n.feed-sort-tabs {\r\n  display: flex;\r\n  overflow-x: auto;\r\n  scrollbar-width: none;\r\n  border-top: 1px solid var(--border-color);\r\n  background-color: var(--card-bg);\r\n}\r\n\r\n.feed-sort-tabs::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.feed-sort-tab {\r\n  flex: 1;\r\n  min-width: fit-content;\r\n  padding: 10px 16px;\r\n  background: none;\r\n  border: none;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.feed-sort-tab:hover {\r\n  background: var(--hover-bg);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.feed-sort-tab.active {\r\n  color: var(--primary-color);\r\n  font-weight: 700;\r\n}\r\n\r\n/* Mobile Sort Dropdown */\r\n.feed-sort-dropdown {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 6px 10px;\r\n  border-radius: 8px;\r\n  transition: background-color 0.2s;\r\n  max-width: none;\r\n}\r\n\r\n.feed-sort-dropdown:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.feed-sort-dropdown option {\r\n  background: var(--card-bg);\r\n  color: var(--text-primary);\r\n  font-size: 14px;\r\n  padding: 8px;\r\n}\r\n\r\n/* Create Post Section */\r\n.feed-create-section {\r\n  padding: 12px 20px;\r\n  border-top: 1px solid var(--border-color);\r\n}\r\n\r\n.create-post-btn {\r\n  width: 100%;\r\n  padding: 10px 16px;\r\n  background: var(--primary-color);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 20px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.create-post-btn:hover {\r\n  background: var(--primary-hover);\r\n}\r\n\r\n.login-prompt-btn {\r\n  text-align: center;\r\n}\r\n\r\n.login-prompt-btn:hover {\r\n  background: var(--primary-hover);\r\n}\r\n\r\n.create-post-inline {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.create-post-textarea {\r\n  width: 100%;\r\n  min-height: 80px;\r\n  padding: 12px;\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 12px;\r\n  color: var(--text-primary);\r\n  font-size: 14px;\r\n  font-family: inherit;\r\n  resize: vertical;\r\n  outline: none;\r\n}\r\n\r\n.create-post-textarea:focus {\r\n  border-color: var(--primary-color);\r\n}\r\n\r\n.create-post-textarea::placeholder {\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.create-post-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.char-count {\r\n  font-size: 13px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.composer-meta-actions {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.preview-create-btn {\r\n  padding: 6px 12px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 14px;\r\n  background: transparent;\r\n  color: var(--text-secondary);\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n\r\n.preview-create-btn:hover:not(:disabled) {\r\n  background: var(--hover-bg);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.action-buttons {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.cancel-create-btn,\r\n.post-create-btn {\r\n  padding: 8px 16px;\r\n  border: none;\r\n  border-radius: 16px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.cancel-create-btn {\r\n  background: var(--bg-secondary);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.cancel-create-btn:hover:not(:disabled) {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.post-create-btn {\r\n  background: var(--primary-color);\r\n  color: white;\r\n}\r\n\r\n.post-create-btn:hover:not(:disabled) {\r\n  background: var(--primary-hover);\r\n}\r\n\r\n.post-create-btn:disabled,\r\n.cancel-create-btn:disabled,\r\n.preview-create-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.refresh-btn {\r\n  background: none;\r\n  border: none;\r\n  padding: 8px 12px;\r\n  cursor: pointer;\r\n  border-radius: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  color: var(--text-primary);\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.refresh-btn.has-new {\r\n  background: rgba(29, 155, 240, 0.12);\r\n  box-shadow: 0 0 0 1px rgba(29, 155, 240, 0.5);\r\n}\r\n\r\n.refresh-btn.has-new .refresh-text,\r\n.refresh-btn.has-new .refresh-icon {\r\n  color: var(--primary-color);\r\n}\r\n\r\n.refresh-btn:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.refresh-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.refresh-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n  color: var(--primary-color);\r\n}\r\n\r\n.refresh-text {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  text-transform: lowercase;\r\n}\r\n\r\n.refresh-count-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 18px;\r\n  height: 18px;\r\n  padding: 0 6px;\r\n  border-radius: 999px;\r\n  background: var(--primary-color);\r\n  color: #fff;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n}\r\n\r\n.new-posts-fab {\r\n  position: fixed;\r\n  top: calc(var(--feed-header-height) + 12px);\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  z-index: 300;\r\n  background: var(--primary-color);\r\n  color: #fff;\r\n  padding: 8px 18px;\r\n  border-radius: 999px;\r\n  border: none;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  transition: transform 0.2s ease, opacity 0.2s ease;\r\n}\r\n\r\n.new-posts-fab:hover {\r\n  transform: translateX(-50%) translateY(-1px);\r\n}\r\n\r\n/* In header-layout mode, feed stick is offset by 60px */\r\n.App.header-layout .new-posts-fab {\r\n  top: calc(var(--feed-header-height) + 72px);\r\n}\r\n\r\n.refresh-icon.spinning {\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n/* Feed Content */\r\n.feed-loading {\r\n  display: flex;\r\n  justify-content: center;\r\n  padding: 40px 20px;\r\n}\r\n\r\n.feed-empty {\r\n  padding: 60px 20px;\r\n  text-align: center;\r\n}\r\n\r\n.feed-empty p {\r\n  color: var(--text-secondary);\r\n  font-size: 15px;\r\n  line-height: 1.5;\r\n  margin: 0;\r\n}\r\n\r\n.feed-posts {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding-left: 10px;\r\n  padding-right: 10px;\r\n}\r\n\r\n/* Load More */\r\n.feed-load-more {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  justify-content: center;\r\n  padding: 20px;\r\n  border-top: 1px solid var(--border-color);\r\n}\r\n\r\n.load-more-spinner {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n\r\n.load-more-btn {\r\n  padding: 10px 24px;\r\n  background: var(--primary-color);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 20px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.load-more-btn:hover:not(:disabled) {\r\n  background: var(--primary-hover);\r\n}\r\n\r\n.load-more-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .desktop-only {\r\n    display: none !important;\r\n  }\r\n  \r\n  .mobile-only {\r\n    display: block !important;\r\n  }\r\n  \r\n  .short-feed {\r\n    border-left: none;\r\n    border-right: none;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .feed-header {\r\n    padding: 12px 8px;\r\n    gap: 4px;\r\n  }\r\n\r\n  .menu-open-btn {\r\n    width: 40px;\r\n    height: 40px;\r\n  }\r\n\r\n  .feed-title {\r\n    font-size: 18px;\r\n  }\r\n  \r\n  .feed-dropdown {\r\n    /*flex: 1;*/\r\n    max-width: none;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    padding: 6px 10px;\r\n  }\r\n  \r\n  .refresh-btn {\r\n    padding: 6px 8px;\r\n    flex-shrink: 0;\r\n  }\r\n  \r\n  .refresh-icon {\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n\r\n  .new-posts-fab {\r\n    top: calc(var(--feed-header-height) + 8px);\r\n    padding: 8px 14px;\r\n    font-size: 12px;\r\n    max-width: calc(100vw - 24px);\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n\r\n  .App.header-layout .new-posts-fab {\r\n    top: calc(var(--feed-header-height) + 68px);\r\n  }\r\n  \r\n  .feed-tabs.desktop-only {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* Mobile Lists Panel */\r\n.mobile-lists-backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 400;\r\n  background: rgba(0, 0, 0, 0.45);\r\n}\r\n\r\n.mobile-lists-panel {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 401;\r\n  width: 75vw;\r\n  max-width: 300px;\r\n  background: var(--bg-primary);\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.3);\r\n  animation: mobile-lists-slide-in 0.22s ease;\r\n}\r\n\r\n@keyframes mobile-lists-slide-in {\r\n  from { transform: translateX(100%); }\r\n  to   { transform: translateX(0); }\r\n}\r\n\r\n.mobile-lists-panel-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 16px;\r\n  border-bottom: 1px solid var(--border-color);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.mobile-lists-panel-title {\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.mobile-lists-panel-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 24px;\r\n  line-height: 1;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  padding: 0 2px;\r\n}\r\n\r\n.mobile-lists-panel-close:hover {\r\n  color: var(--text-primary);\r\n}\r\n\r\n.mobile-lists-panel-list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  overflow-y: auto;\r\n  flex: 1;\r\n}\r\n\r\n.mobile-lists-panel-item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  padding: 14px 16px;\r\n  background: none;\r\n  border: none;\r\n  border-bottom: 1px solid var(--border-color);\r\n  color: var(--text-primary);\r\n  font-size: 15px;\r\n  text-align: left;\r\n  cursor: pointer;\r\n}\r\n\r\n.mobile-lists-panel-item:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.mobile-lists-panel-name {\r\n  flex: 1;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.mobile-lists-panel-count {\r\n  font-size: 12px;\r\n  color: var(--text-secondary);\r\n  flex-shrink: 0;\r\n  margin-left: 8px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
